import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import ChildForm from './ChildForm';
import transformer from '../../common/helpers/transformer';
import type { AppDispatch, RootState } from '../../store';
import { DecryptedItem } from '../../common/types/items';
import type { Child as ChildType } from '../../common/types/child';
import childSelector from '../childSelector';
import { clearCurrentChild, editChild, loadChildById, loadChildren } from '../childrenReducer';

type Props = {
  childId: string;
};

function Child({ childId }: Props) {
  const dispatch: AppDispatch = useDispatch();
  const [editedChild, updateEditedChild] = React.useState<ChildType | null | undefined>(null);

  const item = useSelector<RootState, DecryptedItem<ChildType> | null>(childSelector.getCurrentChild);
  const child = item != null ? item.payload : null;

  const saveChild = async (childToSave: ChildType) => {
    const payload = await transformer.fromObjectToBase64WithEncryption(childToSave);
    await dispatch(editChild({ id: childId, payload }));
    await dispatch(loadChildren());
  };

  React.useEffect(() => {
    dispatch(loadChildById(childId));
    return () => {
      dispatch(clearCurrentChild());
    };
  }, [childId]);

  React.useEffect(() => {
    if (item != null && editedChild == null) {
      updateEditedChild(child);
    }
  }, [child]);

  return (
    <Stack height='100%' overflow='hidden'>
      <Stack px={3} pt={3} pb={1} direction='row' justifyContent='space-between'>
        <Stack direction='row' alignItems='center'>
          <Typography fontSize='1.5rem' mr={4}>
            Kind
          </Typography>
        </Stack>
        <Button disabled={status === 'loading'} variant='contained' onClick={async () => {}}>
          Speichern
        </Button>
      </Stack>
      {editedChild != null && <ChildForm child={editedChild} updateChild={updateEditedChild} saveChild={saveChild} />}
    </Stack>
  );
}

export default Child;
